(function () {
  function initSection(section) {
    const tabs = section.querySelectorAll('.collection-ranking__tab');
    const contents = section.querySelectorAll('.collection-ranking__content');

    function activate(index) {
      tabs.forEach(function (tab) {
        tab.classList.toggle('collection-ranking__tab--active', tab.getAttribute('data-tab') === index);
      });
      contents.forEach(function (content) {
        content.classList.toggle(
          'collection-ranking__content--active',
          content.getAttribute('data-content') === index
        );
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-tab'));
      });
    });

    // 初期表示：最初のタブをアクティブにする
    if (tabs.length > 0) {
      activate(tabs[0].getAttribute('data-tab'));
    }

    // 指定インデックスのタブをアクティブにする（テーマエディタ用）
    section._collectionRankingActivate = activate;
  }

  function initAll(root) {
    (root || document).querySelectorAll('.collection-ranking').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // テーマエディタ：セクションが再描画されたら再初期化する
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  // テーマエディタ：ブロック（タブ）が選択されたら、そのタブを表示する
  document.addEventListener('shopify:block:select', function (event) {
    const section = event.target.closest('.collection-ranking');
    if (!section || typeof section._collectionRankingActivate !== 'function') {
      return;
    }
    // ブロックのshopify_attributesはタブボタンに付いている
    const tab = event.target.closest('.collection-ranking__tab');
    if (tab) {
      section._collectionRankingActivate(tab.getAttribute('data-tab'));
    }
  });
})();
